import { CustomInput, FormGroup } from 'reactstrap';
import { Filter } from '../../ListMessagesBuilder.styles';
import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';

interface FilterStatusProps {
  handleChangeStatusFilter(value: any): void;
  statusValue: string;
  disabled: boolean;
}

export function FilterStatus(props: FilterStatusProps) {
  const allStatusText = useGlotaT('spa.tools.allStatus');
  const approvedText = useGlotaT('spa.tools.approved');
  const disapprovedText = useGlotaT('spa.tools.disapproved');
  const waitingForApprovalText = useGlotaT('spa.tools.waitingForApproval');
  const filterByStatusText = useGlotaT('spa.tools.filterByStatus');
  
  return (
    <Filter>
      <FormGroup>
        <CustomInput
          disabled={props.disabled}
          type="select"
          id="filter-status"
          name="customSelectStatus"
          value={props.statusValue}
          onChange={props.handleChangeStatusFilter}
        >
          <optgroup label={filterByStatusText}>
            <option value="all">{allStatusText}</option>
            <option value="approved">{approvedText}</option>
            <option value="disapproved">{disapprovedText}</option>
            <option value="waitingForApproval">{waitingForApprovalText}</option>
          </optgroup>
        </CustomInput>
      </FormGroup>
    </Filter>
  );
}
